import * as actionsTypes from "./actionTypes";

const publishInterfaceValue = (interfaceId, value) => ({
    type: actionsTypes.CONTROLLER_WIDGET_ACTUATE_ON_INTERFACE,
    interfaceId,
    value
});

export default {
    publishInterfaceValue
}